import SupportView from "@/views/support/SupportView";

export default {
    SupportView
  };